var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import "./App.css";
import AppRoutes from "./setup/routing/AppRoutes";
import { Constants } from "./setup/versioning/Constants";
import { reactPlugin } from "./setup/logging/loggingSetup";
import { AppInsightsContext } from "@microsoft/applicationinsights-react-js";
function App() {
    useEffect(function () {
        console.log("User-login Last Update Time: ", Constants.updateTime);
    }, []);
    return (_jsx(AppInsightsContext.Provider, __assign({ value: reactPlugin }, { children: _jsx(AppRoutes, {}) })));
}
export default App;
